import { StoredBoat, useComparableBoats, useRemoveBoatFromCompare } from '@components/CompareBoats/hooks/useCompare';
import styles from '@styles/SingleBoat/Compare/compare.module.scss';
import { Button, Dropdown, Empty, Grid } from 'antd';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { MainDrawer } from '../../Header/MainDrawer';
import CompareBoatCard from './CompareBoatCard';

type Props = {};

const CompareBoats: FC<Props> = () => {
  const comparableBoats = useComparableBoats();
  const removeBoatFromCompare = useRemoveBoatFromCompare();
  const router = useRouter();

  const boatsLength = useMemo(() => comparableBoats?.length || 0, [comparableBoats]);

  const [drawer, setDrawer] = useState<boolean>(false);

  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();

  useEffect(() => {
    if (!xs) {
      setDrawer(false);
    }
  }, [xs]);

  useEffect(() => {
    if (!boatsLength) {
      setDrawer(false);
    }
  }, [boatsLength]);

  const closeDrawer = useCallback(() => {
    setDrawer((isOpen) => (isOpen ? false : isOpen));
  }, []);

  const BoatsList = useCallback(
    () => (
      <div className={styles.dropdown__container}>
        <div className={styles.container__wrapper}>
          {boatsLength ? (
            <ul className={styles.container__menu}>
              {comparableBoats?.map((item: StoredBoat, index) => {
                if (index > 4) {
                  return null;
                }

                return (
                  <li className={styles.menu__item} key={index}>
                    <CompareBoatCard key={item._id} boat={item} removeBoat={(boat) => removeBoatFromCompare(boat)} />
                  </li>
                );
              })}
            </ul>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}

          {boatsLength >= 4 && (
            <Link href="/compare" className={styles.container__more}>
              View All
            </Link>
          )}
        </div>
      </div>
    ),
    [boatsLength, comparableBoats, removeBoatFromCompare],
  );

  return (
    <>
      {xs ? (
        <Button
          onClick={() => {
            setDrawer(true);
          }}
          type="primary"
          className={styles.buttonPrimary}
        >
          Compare {`(${boatsLength})`}
          <span className={styles.arrowWrapper}>
            <ArrowRight size={16} />
          </span>
        </Button>
      ) : (
        <Dropdown trigger={['hover']} placement="bottomRight" arrow popupRender={() => <BoatsList />}>
          <Button type="primary" ghost className={styles.buttonPrimary} onClick={() => router.push('/compare')}>
            Compare {`(${boatsLength})`}
            <span className={styles.arrowWrapper}>
              <ArrowRight />
            </span>
          </Button>
        </Dropdown>
      )}

      <MainDrawer
        visible={drawer}
        onClose={closeDrawer}
        closable={false}
        className="primaryDrawer"
        goBack={false}
        head={
          <Button onClick={closeDrawer} type="link" className={styles.drawerHeaderBack} icon={<ArrowLeft size={16} />}>
            Compare {`(${boatsLength})`}
          </Button>
        }
      >
        <BoatsList />
        <div className={styles.drawer__footer}>
          <Button type="primary">
            <Link href="/compare">Compare {`(${boatsLength})`}</Link>
          </Button>
        </div>
      </MainDrawer>
    </>
  );
};

export default CompareBoats;
